import classNames from "classnames";
import { useTranslation } from "features/translations";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Container,
  Heading1,
  Heading3,
  Icon,
  LazyRenderingButton,
  Paragraph,
  Tabs,
} from "shared/components";
import { LazyRenderingProvider } from "shared/components/LazyRenderingButton";

import { useTabsState } from "../../../../shared/components/Tabs/Tabs.hooks";
import styles from "./Content009.module.scss";
import { LecturersList } from "./LecturersList";

export const Content009 = ({ payload }) => {
  const { t } = useTranslation();
  const headerTitle = payload?.headerTitle ?? "";
  const listTitle = payload?.listTitle ?? "";
  const people = useMemo(() => {
    return payload?.items ?? [];
  }, [payload?.items]);
  const template = payload?.backgroundColor ?? "light";

  const tabsHeaderEnabled = payload?.showHeaderTabs ?? false;
  const { resetActiveTab, setItems, tabsEnabled } = useTabsState();

  const extractedButtons = [
    ...new Set(people.map((item) => item.position)),
  ].filter(Boolean);

  const [activePositionTab, setActivePositionTab] = useState(
    extractedButtons[0]
  );

  const extractedTabs = useMemo(() => {
    if (tabsHeaderEnabled) {
      return [
        ...new Set(
          people
            .filter(({ position }) => position === activePositionTab)
            .map((item) => item.tags)
            .filter(Boolean)
            .flat()
        ),
      ];
    }
    return [
      ...new Set(
        people
          .map((item) => item.tag)
          .filter(Boolean)
          .flat()
      ),
    ];
  }, [activePositionTab, people, tabsHeaderEnabled]);

  const handleClickOnPositionTab = useCallback(
    (tab) => () => {
      setActivePositionTab(tab);
    },
    []
  );

  useEffect(() => {
    setItems(extractedTabs);
    resetActiveTab();
  }, [resetActiveTab, setItems, extractedTabs]);

  return (
    <div className={classNames(styles.wrapper, styles[template])}>
      <Container className={styles.inner}>
        {tabsHeaderEnabled && (
          <div className={styles.block}>
            <Heading1 className={styles.headline}>{headerTitle}</Heading1>
            <div className={styles.buttons}>
              {extractedButtons.map((button) => (
                <div
                  key={button}
                  className={classNames(styles.position, {
                    [styles["position-active"]]: button === activePositionTab,
                  })}
                  onClick={handleClickOnPositionTab(button)}
                >
                  <Paragraph className={styles.button}>{t(button)}</Paragraph>
                  <Icon name="large_arrow_down" className={styles.icon} />
                </div>
              ))}
            </div>
          </div>
        )}
        <div className={styles.top}>
          <div className={styles.header}>
            <div
              className={classNames(styles.title, {
                [styles["title-margin"]]: tabsHeaderEnabled || tabsEnabled,
              })}
            >
              <Heading3>
                {tabsHeaderEnabled ? t(`our_${activePositionTab}`) : listTitle}
              </Heading3>
            </div>
            <Tabs appearance="justify" />
          </div>
        </div>
        <div className={styles.content}>
          <LazyRenderingProvider
            size={people.length}
            initialLimit={6}
            incrementBy={6}
          >
            <div className={styles.items}>
              <LecturersList
                people={people}
                activePositionTab={activePositionTab}
                tabsHeaderEnabled={tabsHeaderEnabled}
              />
            </div>
            <LazyRenderingButton appearance={template} />
          </LazyRenderingProvider>
        </div>
      </Container>
    </div>
  );
};

export default Content009;
